// extracted by mini-css-extract-plugin
export default {"preserveSpace":"styles_preserveSpace__TBcvG"};